import React from 'react';
import PricingPage from './components/PricingPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <PricingPage />
    </div>
  );
}

export default App;